module.exports = __webpack_public_path__ + "91241d6efb0aab4fd5a2f8ed825c4126.png";